import React from 'react'
import { Grid, Icon, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
let dependencySelected = '';
let optionsArray = [];

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class PracticeFlowResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disableAddDependency: true
        }
        this.removeDependency = this.removeDependency.bind(this);
    }

    setSelectedDependency = (data) => {
        this.setState({
            disableAddDependency: data.target.value && data.target.value !== 'Select' ? false : true
        })
        switch (data.target.name) {
            case 'dependency': dependencySelected = data.target.value ? data.target.value : '';
        }
    }
    addDependenciToActivity() {
        this.setState({
            disableAddDependency: true
        })
        if (dependencySelected && dependencySelected != 'Select') {
            // dispatch.createPack.addDependency(dependencySelected);
            this.props.selectedPracticeFlowActivity.dependencies.push(dependencySelected)
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
            this.resetForm();
            dependencySelected = 'Select';
        }
        else {
            toastr.error('Message', 'Please select Activity from dropdown.');
        }
    }
    getMapping(id) {
        if (this.props.activityOptions) {
            for (let i = 0; i < this.props.activityOptions.length; i++) {
                let activity = this.props.activityOptions[i];
                if (id == activity._id) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id == subActivity._id) {
                            return activity.name + " > " + subActivity.name;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (childActivity) {
                                    if (id == childActivity._id) {
                                        return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }

    }
    removeDependency(id) {
        let index = this.props.selectedPracticeFlowActivity.dependencies.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Dependency</h3>
            <p>Are you sure that you wish to delete this dependency?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    // dispatch.createPack.removeDependency(index)
                    (this.props.selectedPracticeFlowActivity.dependencies).splice(index, 1)
                    dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                    dispatch.lifeCycle.removeEdge({ fromVertex: this.props.selectedPracticeFlowActivity._id.toString(), toVertex: id.toString() })
                }
            }
        });


    }
    resetForm() {
        document.getElementById("dependenciesForm").reset();
    }
    render() {
        optionsArray = [];
        if (this.props.activityOptions) {
            this.props.activityOptions.map((activity) => {
                if (activity.dependencies && activity.dependencies.indexOf(this.props.selectedPracticeFlowActivity._id) === -1) {
                    optionsArray.push({ id: activity._id, label: activity.name });
                }

                if (activity.activities) {
                    activity.activities.map((subActivity) => {
                        if (((!this.props.showChildren && subActivity.isParentNode) || (this.props.showChildren)) && (subActivity.dependencies && subActivity.dependencies.indexOf(this.props.selectedPracticeFlowActivity._id) === -1))
                            optionsArray.push({ id: subActivity._id, label: activity.name + " > " + subActivity.name });
                        if (this.props.showChildren) {
                            if (subActivity.activities) {
                                subActivity.activities.map((childActivity) => {
                                    if (childActivity && childActivity.dependencies && childActivity.dependencies.indexOf(this.props.selectedPracticeFlowActivity._id) === -1)
                                        optionsArray.push({ id: childActivity._id, label: activity.name + " > " + subActivity.name + " > " + childActivity.name });
                                })
                            }
                        }

                    })
                }

            });
        }
        const showForm = () => {
            if (this.props.status === 0) {
                return (
                    <Form
                        noValidate
                        className="formcyForm"
                        name='dependenciesForm'
                        id='dependenciesForm'
                        ref={ref => this.form = ref}
                        onValidSubmit={(formData) => { this.addDependenciToActivity(formData) }}>
                        <Grid.Row>
                            <Form.Group inline >
                                <Grid.Column width={14}>
                                    <div>
                                        <Form.Field
                                            placeholder="Dependency"
                                            name='dependency'
                                            id='dependency'
                                            required
                                            onChange={this.setSelectedDependency}
                                            control='select' >
                                            <option>Select</option>
                                            {optionsArray && optionsArray.map((activity) => {
                                                if (this.props.selectedPracticeFlowActivity.dependencies && this.props.selectedPracticeFlowActivity.dependencies.indexOf(activity.id) === -1 && this.props.selectedPracticeFlowActivity._id !== activity.id)
                                                    return <option key={activity.id} value={activity.id}>{activity.label}</option>
                                            })}
                                        </Form.Field>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={2}>
                                    <Button icon="plus" type="submit" id="submit" disabled={this.state.disableAddDependency}></Button>
                                </Grid.Column>
                            </Form.Group>
                        </Grid.Row>
                    </Form>
                )
            }
        }
        const showDeleteButton = (dependency) => {
            if (this.props.status === 0) {
                return (
                    <Grid.Column width={2}>
                        <Button className="trash-color" icon="trash alternate" style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }} onClick={() => this.removeDependency(dependency)}></Button>
                    </Grid.Column>
                )
            }
        }
        return (

            <Grid columns={2} >
                {this.props.showResourecePaneFlag === "PracticeFlow" ? showForm() : ''}
                {this.props.selectedPracticeFlowActivity.dependencies && this.props.selectedPracticeFlowActivity.dependencies.map((dependency) => {

                    return (<Grid.Row key={dependency}>
                        <Grid.Column width={14}>
                            <div className="divBlock"> <Icon name="linkify" color="purple" /> &nbsp; &nbsp; {this.getMapping(dependency)}</div>
                        </Grid.Column>
                        {showDeleteButton(dependency)}
                    </Grid.Row>)

                })}
                {this.props.selectedPracticeFlowActivity.dependencies && this.props.selectedPracticeFlowActivity.dependencies.length === 0 ?
                    <span className="clr-orange">No dependencies to display</span> : ""
                }


            </Grid>

        )
    }
}

export default PracticeFlowResourcePaneForm